module.exports = __webpack_public_path__ + "img/title-bg.50a83598.png";